import axios from "axios";
import * as TimesTypes from "../../types/user/TimesTypes";
//import moment from "moment";
import dayjs from "dayjs";

export const userTodayTimesAction =
  (companyId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TimesTypes.USER_TIMING_TODAY_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        date: dayjs(date).format("YYYY-MM-DD"),
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/timerecord/${companyId}/date`,
        body,
        config
      );
      dispatch({
        type: TimesTypes.USER_TIMING_TODAY_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: TimesTypes.USER_TIMING_TODAY_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userDashTodayTimesAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TimesTypes.USER_DASHBOARD_TIMING_TODAY_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        date: dayjs(new Date()).format("YYYY-MM-DD"),
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/timerecord/${companyId}/date`,
        body,
        config
      );
      dispatch({
        type: TimesTypes.USER_DASHBOARD_TIMING_TODAY_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: TimesTypes.USER_DASHBOARD_TIMING_TODAY_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userPrevTimesAction =
  (companyId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TimesTypes.USER_TIMING_PREV_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        date: dayjs(date).subtract(1, "day").format("YYYY-MM-DD"),
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/timerecord/${companyId}/date`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: TimesTypes.USER_TIMING_PREV_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: TimesTypes.USER_TIMING_PREV_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userMonthTimerAction =
  (date, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TimesTypes.USER_TIMING_MONTH_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        month: `${dayjs(date).format("M")}`,
        year: `${dayjs(date).format("YYYY")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/timerecord/${companyId}/month`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: TimesTypes.USER_TIMING_MONTH_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: TimesTypes.USER_TIMING_MONTH_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userRangeDashAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TimesTypes.USER_RANGE_DASHBOARD_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        startSevenDate: `${dayjs(new Date())
          .subtract(7, "days")
          .format("YYYY-MM-DD")}`,
        endSevenDate: `${dayjs(new Date()).format("YYYY-MM-DD")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/timerecord/${companyId}/dashboard/data`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: TimesTypes.USER_RANGE_DASHBOARD_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: TimesTypes.USER_RANGE_DASHBOARD_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userWeekDashAction = (companyId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: TimesTypes.USER_WEEK_DASHBOARD_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const body = {
      startSevenDate: `${dayjs(new Date()).weekday(1).format("YYYY-MM-DD")}`,
      endSevenDate: `${dayjs(new Date()).weekday(7).format("YYYY-MM-DD")}`,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/timerecord/${companyId}/dashboard/data`,
      body,
      config
    );
    // console.log(data?.data);
    dispatch({
      type: TimesTypes.USER_WEEK_DASHBOARD_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: TimesTypes.USER_WEEK_DASHBOARD_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const userRangeTotalTimeAction =
  (startDate, endDate, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: TimesTypes.USER_RANGE_WISE_TIME_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        startDate: `${dayjs(startDate).format("YYYY-MM-DD")}`,
        endDate: `${dayjs(endDate).format("YYYY-MM-DD")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/timerecord/${companyId}/total/time`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: TimesTypes.USER_RANGE_WISE_TIME_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: TimesTypes.USER_RANGE_WISE_TIME_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
